import React, { useState, useEffect } from "react";
import { RiArrowDownSLine } from "react-icons/ri";

const Accordian = ({ icon, title, children, defaultOpen = false }) => {
  // ✅ initialize from prop
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [hasOpened, setHasOpened] = useState(defaultOpen);

  useEffect(() => {
    const handlePdfExport = () => setHasOpened(true);
    window.addEventListener("pdf-export-start", handlePdfExport);
    return () =>
      window.removeEventListener("pdf-export-start", handlePdfExport);
  }, []);

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
    setHasOpened(true);
  };

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { hasOpened });
    }
    return child;
  });

  return (
    <div className="block w-full max-w-full" data-pdf-accordion-wrapper>
      <div
        className="px-3 py-2 bg-[#2a5775] rounded-t-md cursor-pointer"
        onClick={toggleAccordion}
        data-pdf-accordion-header
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm">
            <img alt="icon" className="w-6 h-6" src={icon} />
            <p className="text-white font-medium">{title}</p>
          </div>

          <RiArrowDownSLine
            size={26}
            color="white"
            className={`transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
      </div>

      <div
        data-accordion-content
        style={{
          height: isOpen ? "auto" : "0",
          opacity: isOpen ? "1" : "0",
          overflow: "hidden",
          visibility: isOpen ? "visible" : "hidden",
        }}
      >
        <div className="block w-full max-w-full bg-white border border-gray-200 rounded-b-md p-3 overflow-hidden">
          {childrenWithProps}
        </div>
      </div>
    </div>
  );
};

export default Accordian;
